import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBackRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", fillRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, clipRule: "evenodd", viewBox: "0 0 20 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "m9.67 13.74.44.44 3.94-3.96a.3.3 0 0 0 .07-.34.3.3 0 0 0-.07-.1l-3.97-3.96-.44.44 3.43 3.43H5.86v.62h7.22l-3.41 3.43Z" }));
const ForwardRef = forwardRef(SvgArrowBackRight);
export { ForwardRef as ReactComponent };
